// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_of-0";